export const imageBaseApi = window.APP_CONFIG.api2.baseapi;
